import React from 'react';

/*
  A strip of numbers on hairlines.

  **Rule 5: numbers sit on hairlines, never in tiles.** Group G's drawings put
  the same strip at the top of a saved replenishment run and an opened movement
  run, so it is one component rather than two that will drift.

  **The count that needs acting on is the one in colour.** Rule 9's cousin: four
  numbers all in the same ink read as four facts, and one of them is usually a
  problem somebody has to do something about. Pass `tone` for that one, and only
  when it is not zero, because a red 0 is a warning about nothing.

  **Two by two below 700, not four across**, which the stylesheet does. Group G
  corrected exactly this at 390 on 4 September 2026 and left it broken at 834 and
  700 on six drawings that were already signed off. The lesson it left behind is
  that a layout rule corrected at one size gets checked at every size it applies
  to, in the same sitting.
*/
export function Figure({ n, label, tone }) {
  return (
    <div className="mv-fig">
      <div className="mv-fig-n" style={tone ? { color: tone } : undefined}>{n}</div>
      <div className="mv-fig-l">{label}</div>
    </div>
  );
}

export function Figures({ children }) {
  return <div className="card mv-figs">{children}</div>;
}
